import { gql } from '@apollo/client';

export const QUERY_GYMS = gql`
    query users (
        $filters: GymFiltersInput,
        $pagination: PaginationArg = {},
        $sort: [String] = []) {
        gyms (filters: $filters, pagination: $pagination, sort: $sort) {
            data {
                id
                attributes {
                    name
                    address
                    enabled
                    city {
                        data {
                            id
                            attributes {
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;